import isSomeValueEmpty from '@anm/helpers/is/isSomeValueEmpty';
import isAppSumoSubscription from '@anm/helpers/subscription/isAppSumoSubscription';
import isStaffSubscription from '@anm/helpers/subscription/isStaffSubscription';
import { FC } from 'react';

import CurrentAppSumoPlan, { CurrentAppSumoPlanProps } from '../CurrentAppSumoPlan';
import CurrentCancelPlan, { CurrentCancelPlanProps } from '../CurrentCancelPlan';
import CurrentFreePlan from '../CurrentFreePlan';
import CurrentPayPlan, { CurrentPayPlanProps } from '../CurrentPayPlan';
import CurrentPlanLoader from '../CurrentPlanLoader';
import CurrentStaffPlan, { CurrentStaffPlanProps } from '../CurrentStaffPlan';

type CurrentPlanSwitcherProps = Partial<CurrentAppSumoPlanProps> &
  Pick<CurrentPayPlanProps, 'subscriptionPlan' | 'upgradeRoute'> &
  Partial<CurrentPayPlanProps> & {
    isPending: boolean;
    isFreeUser: boolean;
    expirationDate?: number;
    appSumoSubmitError?: string;
    onConfirmAppSumoUpgrade: () => void;
  };

const CurrentPlanSwitcher: FC<CurrentPlanSwitcherProps> = ({
  period,
  planName,
  isPending,
  isFreeUser,
  nextInvoice,
  nextInvoiceDate,
  annualPrice,
  monthlyPrice,
  upgradeRoute,
  expirationDate,
  hasUserCard,
  subscriptionPlan,
  appSumoSubmitError,
  onRedeem,
  onCancel,
  onPeriodSwitch,
  onConfirmAppSumoUpgrade
}) => {
  const appSumoPlanRequiredProps = {
    plan: subscriptionPlan,
    onRedeem,
    onConfirm: onConfirmAppSumoUpgrade
  } as CurrentAppSumoPlanProps;

  const staffPlanProps = {
    period,
    planName
  } as CurrentStaffPlanProps;

  const cancelPlanRequiredProps = {
    period,
    planName,
    upgradeRoute,
    date: expirationDate
  } as CurrentCancelPlanProps;

  const payPlanRequiredProps = {
    period,
    planName,
    annualPrice,
    monthlyPrice,
    upgradeRoute,
    subscriptionPlan,
    onCancel,
    onPeriodSwitch
  } as CurrentPayPlanProps;

  switch (true) {
    case isPending:
      return <CurrentPlanLoader />;

    case !isSomeValueEmpty(cancelPlanRequiredProps):
      return <CurrentCancelPlan {...cancelPlanRequiredProps} />;

    case isAppSumoSubscription(subscriptionPlan) && !isSomeValueEmpty(appSumoPlanRequiredProps):
      return (
        <CurrentAppSumoPlan submitError={appSumoSubmitError} hasUserCard={hasUserCard} {...appSumoPlanRequiredProps} />
      );

    case !isSomeValueEmpty(payPlanRequiredProps) && !isFreeUser:
      return <CurrentPayPlan nextInvoice={nextInvoice} nextInvoiceDate={nextInvoiceDate} {...payPlanRequiredProps} />;

    case isStaffSubscription(subscriptionPlan) && !isSomeValueEmpty(staffPlanProps):
      return <CurrentStaffPlan {...staffPlanProps} />;

    default:
      return <CurrentFreePlan route={upgradeRoute} />;
  }
};

export default CurrentPlanSwitcher;
